import { environment } from '../../../environments/environment';

function createUrl(actionName: string): string {
  return `${environment.apiBaseUrl}${environment.apiUrl}${environment.apiVersion}${actionName}`;
}

export const SharedApiResources = {
  countries: createUrl('countries'),
  states: createUrl('states'),
  stateTaxes: createUrl('state-taxes'),
  taxClass: createUrl('tax-class'),
  currencies: createUrl('currencies'),
  paymentMethods: createUrl('payment-methods'),
  scopes: createUrl('scopes'),
  stages: createUrl('stages'),
  sources: createUrl('sources'),
  bidTypes: createUrl('bid-types'),
  moduleStatues: createUrl('status'),
  moduleTemplate: createUrl('template/module?search='),
  getModuleTemplateBySlug: createUrl('template/module?slug='),
  getModuleTemplateSettingBySlug: createUrl('template/moduleSetting?slug='),
  getModuleStatusById: createUrl('status-setting'),
  getNotification: createUrl('notifications?'),
  createNotificationMarkAsSeen: createUrl('notifications/seen'),
  NotificationResetCounter: createUrl('notifications/reset-counter'),
  setUserStatus: createUrl('user/set-status'),
  getUserStatusOption: createUrl('user/status-options'),
  CreateWatcher: createUrl('watch'),
  creareNotificationMarkAllRead: createUrl('notifications/mark-all-read'),
  createMarkAsUnseen: createUrl('notifications/unseen'),
  pingUserActivity: createUrl('user/ping-activity'),
  getUserStatus: createUrl('user/status'),
  updateRequestTakeoffStatus: createUrl('request/takeoffs/status/'),
  //changeUserPassword : createUrl ('change-password'),
  changeUserPassword: createUrl('change-password'),
};

export const CurrencyMaskOptions = {
  prefix: '',
  thousands: ',',
  decimal: '.',
  precision: '2',
  align: 'left',
  max: 99999999.99,
  allowNegative: false,
};

export const CurrencyMaskOptionsNegativeAllowed = {
  prefix: '',
  thousands: ',',
  decimal: '.',
  precision: '2',
  align: 'left',
  max: 99999999.99,
};
